import { useContext } from 'react';

import { receptionistsContext } from './receptionistsContext';

export const useReceptionists = () => {
  const data = useContext(receptionistsContext);

  if (data === undefined) {
    throw new Error('useReceptionists must be called inside a ReceptionistsProvider and with a value');
  }

  return data;
};
